exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text[data-v-3998cf04]{color:#909399}.box[data-v-3998cf04]{background:#fff;padding:10px 30px;border-radius:20px}", ""]);

// exports
